// True inside the Masjid 24/7 Home Android app, false in a browser.
export const isNativeApp = (): boolean =>
  !!(window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor?.isNativePlatform?.();

// Set by the Android app on a TV (app 1.4+).
export const isTv = (): boolean => (window as Window & { m247Tv?: boolean }).m247Tv === true;

// How the TV is fixed to the wall. TVs never turn an app, so on its side app 1.6+ turns its own
// picture, and portrait layouts and masjid screens then fill the TV.
export type TvPosition = "normal" | "left" | "right";
const TV_ROTATION: Record<TvPosition, number> = { normal: 0, left: 90, right: 270 };

export const canTurnTv = (): boolean =>
  isTv() && (window as Window & { m247CanRotate?: boolean }).m247CanRotate === true;

export const turnTv = (position: TvPosition = "normal"): void =>
  (window as Window & { m247Screen?: { postMessage: (message: string) => void } }).m247Screen?.postMessage(
    JSON.stringify({ tvRotation: TV_ROTATION[position] }),
  );
